/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiRequestInterceptorService } from 'reg-hub-common';
import { AuthInterceptorService } from '../services/auth-interceptor/auth-interceptor.service';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ApiRequestInterceptorService, multi: true }
];